import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {Router} from 'react-router-dom';
import {createBrowserHistory} from 'history';
//MUI
import Box from '@material-ui/core/Box';
//RUTAS
import Routes from './Routes';
//REDUX
import {closeMsg} from './redux-app';
//DS
import {baseName} from 'config/keys';
import {useVerificar} from 'hooks';
import {DialogDs, LoadingModal, Sidebar} from 'lib.front';
const browserHistory = createBrowserHistory({basename: baseName});

function AppDS({
   loading,
   modalProps,
   msgProps,
   overlayProps,
   sidebarProps,
   auth,
   handleCloseMsgModal
}) {
   const verificar = useVerificar();
   useEffect(verificar, []);
   return (
      <>
         <Router basename={baseName} history={browserHistory}>
            <Routes logged={auth.logged} />
         </Router>
         <Box {...overlayProps} />
         <DialogDs {...modalProps} />
         <Sidebar {...sidebarProps} />
         <LoadingModal open={loading} />
         <DialogDs titulo="Aviso" onClose={handleCloseMsgModal} {...msgProps}></DialogDs>
      </>
   );
}
function mapStateToProps(state) {
   return {
      loading: state.loading.open,
      modalProps: state.modal,
      msgProps: state.msg,
      overlayProps: state.overlay,
      sidebarProps: state.sidebar,
      auth: state.auth
   };
}
function mapDispatchToProps(dispatch) {
   return {
      handleCloseMsgModal: () => dispatch(closeMsg())
   };
}
export default connect(mapStateToProps, mapDispatchToProps)(AppDS);
